import { ChangeDetectorRef, Component, EventEmitter, input, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, takeUntil } from 'rxjs';
import { ApprovalRule } from 'src/app/Modules/settings/models/common/setting-area.model';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-rules-approvals',
    templateUrl: './rules-approvals.component.html',
    styleUrls: ['./rules-approvals.component.scss'],
})
export class RulesApprovalsComponent {
    ruleconfigureForm: UntypedFormGroup;
    // @Input() idmsFormGroup: UntypedFormGroup;
    @Output() ruleConfigureFormEmmiter = new EventEmitter<any>();
    @Output() clearRuleValuesDataEmmiter = new EventEmitter<any>();
    @Input() ruleValues: any;
    rules: ApprovalRule[] = [];
    selectedRule: ApprovalRule;
    contentPageVisible: boolean = true;
    approvalDeliveryGroups: any[];
    private destroy$ = new Subject<void>();
    constructor(
        private cd: ChangeDetectorRef,
        private toastrService: CustomToastService,
        private mgmtApi: ManagementApiService,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private formBuilder: UntypedFormBuilder,
        private globalEmiiterService: GlobalEmittersService,
        private transLocoService: TranslocoService
    ) {}

    ngOnInit(): void {
        this.LoadRules();
        this.createFormControls();
        this.globalEmiiterService.rulesSaveEvent.subscribe((resp) => {
            if (resp) {
                let resultpayload: any = [];
                let isSave: boolean = false;
                if (this.ruleconfigureForm.valid) {
                    this.ruleValues.forEach((j) => {
                        let data = [];
                        let arrGroups = j.groups;
                        let _selectedRule = this.rules.find((m) => m.approvalRuleId == j.ApprovalRuleId);
                        if (arrGroups) {
                            arrGroups.forEach((i) => {
                                var k;

                                if (_selectedRule && _selectedRule?.approvalDeliveryGroups) {
                                    var _deliveryGroupData = _selectedRule?.approvalDeliveryGroups.find((m) => m.deliveryGroup?.deliveryGroupId == i);
                                    if (_deliveryGroupData) {
                                        k = { approvalDeliveryGroupId: _deliveryGroupData.approvalDeliveryGroupId, deliveryGroupid: i };
                                        data.push(k);
                                    } else {
                                        k = { deliveryGroupid: i };
                                        data.push(k);
                                    }
                                } else {
                                    k = { deliveryGroupid: i };
                                    data.push(k);
                                }
                            });
                            //To delete unselected delivery groups
                            if (j?.ApprovalRuleId && j?.ApprovalRuleId != '0' && _selectedRule?.approvalDeliveryGroups?.length > 0) {
                                _selectedRule?.approvalDeliveryGroups.forEach((row) => {
                                    let index = arrGroups.findIndex((m) => m == row.deliveryGroup.deliveryGroupId);
                                    if (index < 0) {
                                        var k = { approvalDeliveryGroupId: row.approvalDeliveryGroupId, active: false };
                                        data.push(k);
                                    }
                                });
                            }
                        }
                        if (j?.ApprovalRuleId && j?.ApprovalRuleId != '0') {
                            let row = {
                                name: j.name,
                                approvalTrigger: j.trigger,
                                approvalItem: j.item,
                                approvalAction: j.action,
                                approvalDeliveryGroups: data,
                                enabled: j.enabled,
                                ApprovalRuleId: j.ApprovalRuleId,
                            };
                            resultpayload.push(row);
                        } else {
                            let row = {
                                name: j.name,
                                approvalTrigger: j.trigger,
                                approvalItem: j.item,
                                approvalAction: j.action,
                                approvalDeliveryGroups: data,
                                enabled: j.enabled,
                            };
                            resultpayload.push(row);
                            // isSave = true;
                        }
                    });
                }

                if (resultpayload.length > 0) {
                    this.ngxUiLoaderService.start();

                    this.mgmtApi.updateRules(resultpayload).subscribe(
                        async (resp) => {
                            if (resp.success) {
                                // This block runs regardless of the outcome (success or error)
                                this.ngxUiLoaderService.stop();
                                this.toastrService.successToast(
                                    this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.THE_RULE_HAS_BEEN_SAVED_SUCCESSFULLY')
                                );
                                this.LoadRules(this.selectedRule);
                                this.ruleconfigureForm.markAsPristine();
                                this.clearRuleValuesDataEmmiter.emit(true);
                            } else {
                                this.ngxUiLoaderService.stop();
                                this.user_utility.errorModelPopup(resp.message);
                            }
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                            this.user_utility.errorModelPopup(err);
                        }
                    );
                }
            }
        });

        this.globalEmiiterService.updateStatus.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
            if (data) {
                if (this.selectedRule) this.selectedRule.name = data?.name;
                else this.selectedRule = data;
                this.ruleconfigureForm.get('name').setValue(data?.name);
                this.ruleConfigureFormEmmiter.emit(this.ruleconfigureForm);
                this.globalEmiiterService.updateStatus.next(null);
            }
        });
    }

    createFormControls() {
        this.ruleconfigureForm = this.formBuilder.group({
            ApprovalRuleId: [],
            trigger: [, [Validators.required]],
            item: [, [Validators.required]],
            groups: [, [Validators.required]],
            action: [, [Validators.required]],
            enabled: [this.selectedRule?.enabled ? this.selectedRule?.enabled : false, [Validators.required]],
            name: [this.selectedRule?.name ? this.selectedRule?.name : '', [Validators.required]],
        });
    }

    selectedRoleIdHandler(event: any) {
        this.selectedRule = event?.item;
        let data = [];
        const existing = this.ruleValues.find((ctrl) => ctrl.ApprovalRuleId === this.selectedRule?.approvalRuleId);
        if (existing && this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0') {
            this.ruleconfigureForm.get('ApprovalRuleId').setValue(this.selectedRule.approvalRuleId);
            this.ruleconfigureForm.get('trigger').setValue(existing.trigger);
            this.ruleconfigureForm.get('action').setValue(existing.action);
            this.ruleconfigureForm.get('enabled').setValue(existing.enabled);
            this.ruleconfigureForm.get('item').setValue(existing.item);
            this.ruleconfigureForm.get('name').setValue(existing.name);
            existing?.groups.forEach((i) => {
                if (!data.find((ctrl) => ctrl === i)) {
                    data.push(i);
                }
            });
            this.ruleconfigureForm.get('groups').setValue(data);
        } else {
            if (this.selectedRule?.name) this.ruleconfigureForm.get('name').setValue(this.selectedRule.name);
            if (this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0') {
                this.ruleconfigureForm.get('ApprovalRuleId').setValue(this.selectedRule.approvalRuleId);
            } else {
                this.ruleconfigureForm.get('ApprovalRuleId').setValue(null);
            }
            // if (this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0') {
            this.ruleconfigureForm.get('trigger').setValue(this.selectedRule.trigger);
            this.ruleconfigureForm.get('action').setValue(this.selectedRule.action);
            this.ruleconfigureForm.get('enabled').setValue(this.selectedRule.enabled);
            this.ruleconfigureForm.get('item').setValue(this.selectedRule.item);
            if (this.selectedRule.approvalDeliveryGroups) {
                let approvalDeliveryGroups = this.selectedRule.approvalDeliveryGroups;
                this.approvalDeliveryGroups = approvalDeliveryGroups;

                approvalDeliveryGroups.forEach((i) => {
                    if (this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0') {
                        data.push(i.deliveryGroup.deliveryGroupId);
                    } else {
                        data.push(i);
                    }
                });

                this.ruleconfigureForm.get('groups').setValue(data);
            } else {
                this.ruleconfigureForm.get('groups').setValue([]);
            }
        }

        this.contentPageVisible = false;
        this.cd.detectChanges();
        this.contentPageVisible = true;
        this.ruleConfigureFormEmmiter.emit(this.ruleconfigureForm);
    }

    deleteDataHandler(event) {
        this.selectedRule = event;
        if (this.selectedRule?.approvalRuleId && this.selectedRule?.approvalRuleId != '0') {
            let data = [
                {
                    approvalRuleId: this.selectedRule.approvalRuleId,
                    active: false,
                },
            ];
            this.ngxUiLoaderService.start();
            this.mgmtApi.deleteRules(data).subscribe(
                async (resp) => {
                    if (resp.success) {
                        this.ngxUiLoaderService.stop();
                        this.toastrService.successToast(this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.THE_RULE_HAS_BEEN_DELETED_SUCCESSFULLY'));

                        this.selectedRule = null;
                        this.LoadRules(null);
                        this.clearRuleValuesDataEmmiter.emit(true);
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup(resp.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                    this.user_utility.errorModelPopup(
                        this.transLocoService.translate(
                            'SETTING_PAGE.IDMS_SETTINGS.ERROR_WHILE_DELETING_THE_RULE_PLEASE_TRY_AGAIN_OR_CONTACT_THE_ADMINISTRATOR'
                        )
                    );
                }
            );
        } else {
            this.toastrService.successToast(this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.THE_RULE_HAS_BEEN_DELETED_SUCCESSFULLY'));

            this.selectedRule = null;
            this.LoadRules(null);
            this.clearRuleValuesDataEmmiter.emit(true);
        }
    }

    ruleConfigureFormHandler(event) {
        console.log('in approval form', event);
        this.ruleconfigureForm = event;
        if (!event?.value?.ApprovalRuleId || event?.value?.ApprovalRuleId == '0') {
            const formValues = this.ruleconfigureForm.value;

            // Find the index of the rule to update
            const index = this.rules.findIndex((rule) => !rule.approvalRuleId || rule.approvalRuleId == '0');

            if (index !== -1) {
                // Update the rule in the array
                const ruleToUpdate = this.rules[index];
                if (formValues.trigger) {
                    ruleToUpdate.trigger = formValues.trigger;
                }
                if (formValues.item) {
                    ruleToUpdate.item = formValues.item;
                }
                if (formValues.action) {
                    ruleToUpdate.action = formValues.action;
                }
                if (formValues.enabled !== undefined) {
                    ruleToUpdate.enabled = formValues.enabled;
                }
                if (formValues.groups) {
                    ruleToUpdate.approvalDeliveryGroups = formValues.groups;
                }
            }
        }
        this.ruleConfigureFormEmmiter.emit(this.ruleconfigureForm);
    }

    async LoadRules(selectedRule?: any) {
        let data = await this.mgmtApi.getRules().toPromise();
        if (data.success) {
            this.rules = data.response;
            if (!selectedRule) this.selectedRule = null;
            else {
                if (selectedRule?.approvalRuleId == '0') {
                    this.selectedRule = this.rules.find((m) => m.item == selectedRule.item && m.trigger == selectedRule?.trigger); //Only while create rules
                } else {
                    this.selectedRule = this.rules.find((m) => m.approvalRuleId == selectedRule.approvalRuleId); //Trigger this line For edit Rule
                }
                // this.selectedRule = selectedRule;
            }
            this.cd.detectChanges();
        } else {
            this.user_utility.errorModelPopup(data.message);
        }
    }
    enableDisableHandler(event) {
        // this.selectedRule = event?.item;
        this.selectedRule.enabled = event;
        this.ruleconfigureForm.get('enabled').setValue(event);
        this.ruleConfigureFormEmmiter.emit(this.ruleconfigureForm);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
